var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"a-input a-input--disabled "},[_vm._v("\n  "+_vm._s(_vm.$t('form.notifications.bid-clarification-received', { lotNumber: _vm.lotNumber, lotName: _vm.lotName, bidNum: _vm.bidNum }))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }